import { useParams } from "react-router";
import { TopBar } from "../components/TopBar";
import { meanField } from "../lib/stats";
import { useManifestStore } from "../state/manifestStore";

export function Projects() {
  const { tenant } = useParams();
  const manifest = useManifestStore((s) => s.manifest);
  if (!manifest || !tenant) return null;
  const projects = manifest.projects.filter((p) => p.tenant === tenant);
  const sessions = manifest.sessions.filter((s) => s.tenant === tenant);

  return (
    <>
      <TopBar tenant={tenant} title="Projects" />
      <div className="app-content">
        <div className="card">
          <table className="roster">
            <thead>
              <tr>
                <th>Project</th>
                <th>Flavor</th>
                <th>Vendor</th>
                <th>Function</th>
                <th>Sessions</th>
                <th>Mean success</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((p) => {
                const ps = sessions.filter((s) => s.project === p.id);
                const meanSuccess = meanField(ps, (s) => s.scores.overall_success);
                return (
                  <tr key={p.id}>
                    <td>{p.name}</td>
                    <td>
                      <span className={`badge flavor-${p.flavor}`}>
                        {p.flavor.replace("_", " ")}
                      </span>
                    </td>
                    <td>{p.vendor || "—"}</td>
                    <td>{p.function}</td>
                    <td className="mono">{ps.length}</td>
                    <td className="mono">{meanSuccess}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
